module.exports = __webpack_public_path__ + "img/argolas.ebb5bf15.png";